import * as React from 'react'
import { Drawer, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle } from '@/components/ui/drawer'
import { cn } from '@/lib/utils'

interface DrawerBuilderProps {
  open: boolean
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>
  title: React.ReactNode
  description?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  className?: string
  bodyClassName?: string
  headerClassName?: string
}

export function DrawerBuilder({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  side = 'right',
  className,
  bodyClassName,
  headerClassName,
}: DrawerBuilderProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} direction={side}>
      <DrawerContent className={cn('w-full sm:max-w-lg p-0', className)}>
        <DrawerHeader className={cn('border-b p-4 pr-12', headerClassName)}>
          <DrawerTitle>{title}</DrawerTitle>
          {description ? <DrawerDescription>{description}</DrawerDescription> : null}
        </DrawerHeader>

        <div className={cn('flex-1 overflow-y-auto p-4', bodyClassName)}>
          {children}
        </div>

        {footer ? <DrawerFooter className="border-t p-4">{footer}</DrawerFooter> : null}
      </DrawerContent>
    </Drawer>
  )
}
